import { Style } from '../interface/Style.ts';

class GetStylesResponse {
	styles: Style[];

	constructor(stylesData: Style[]) {
		this.styles = stylesData;
	}

	formatStylesData() {
		if (Array.isArray(this.styles)) {
			return this.styles.map((style) => ({
				baseModelId: style.base_model,
				categoryIds: style.category_ids,
				id: style.id,
				image: style.image_url,
				name: style.name,
				runCount: style.run_count,
			}));
		}
		return [];
	}
}

export default GetStylesResponse;
